export enum MapSize {
    None, Small, Half, Full
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/map-size.ts